import { TooltipProvider } from '@/components/ui/tooltip';
import { NavSections } from './nav-sections';
import { useNavAccordion } from './useNavAccordion';
import type { SideMenuConfiguration } from './side-menu.types';

interface SideMenuProps extends SideMenuConfiguration {
  collapsed?: boolean;
}

const SideMenuUI = ({ sideMenuData, collapsed = false }: SideMenuProps) => {
  const mainItems = sideMenuData.filter((c) => !c.bottom);
  const bottomItems = sideMenuData.filter((c) => c.bottom);
  // One shared accordion owner for both NavSections instances below — see
  // useNavAccordion's doc comment for why this can't live inside NavSections.
  const { openSections, toggleSection } = useNavAccordion();

  return (
    <TooltipProvider delayDuration={collapsed ? 100 : 999999}>
      <aside
        className={[
          'flex h-full shrink-0 flex-col border-r border-border bg-background transition-[width] duration-200 ease-in-out overflow-hidden',
          collapsed ? 'w-16' : 'w-60',
        ].join(' ')}
      >
        <nav className="flex-1 overflow-y-auto py-2 space-y-0.5">
          <NavSections
            sections={mainItems}
            variant="sidebar"
            collapsed={collapsed}
            openSections={openSections}
            onToggleSection={toggleSection}
          />
        </nav>
        {bottomItems.length > 0 && (
          <div className="shrink-0 border-t border-border py-2 space-y-0.5">
            <NavSections
              sections={bottomItems}
              variant="sidebar"
              collapsed={collapsed}
              openSections={openSections}
              onToggleSection={toggleSection}
            />
          </div>
        )}
      </aside>
    </TooltipProvider>
  );
};

export default SideMenuUI;
